// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Vw_u","inner":"Form_inner__1a_Yk","range":"Form_range__3lzC4","name":"Form_name__1VTP6","actions":"Form_actions__3B-UA"};